import angular from 'angular';
const xbrowser_module = angular.module('mw.xbrowser', []);
export default xbrowser_module.name;
// mw-no-hide
// removes mw-hide CSS class
// this is useful for showing certain elements only in supported browsers
// example:
// <div class="mw-hide" mw-no-hide><p>hello..</p></div>
// => contents of the div are hidden (due to mw-hide), but after
// angular processes mw-no-hide, mw-hide will be removed and the paragraph is visible
// NOTE: ng-cloak would be perfect solution to this, if it would work in ie8
// it seems in ie8 <div ng-cloak class="ng-cloak"> will be visible...
xbrowser_module.directive('mwNoHide', MwNoHide);
function MwNoHide() {
    var linkFunction = function (scope, element, attributes) {
        // this would be the brute force no-jquery way
        // element[0].className = '';
        // and this would be the jQuery way (replace jQuery with mjQ for our injectable version)
        // mjQ(element).removeClass('mw-hide');
        // .. but because we're inside an angular directive, element is
        // atleast a jqLite element which has removeClass, so we can just
        // forget any dependencies (tested that it works without jQuery loaded)
        element.removeClass('mw-hide');
    };
    // return the directive definition object as recommended in
    // https://docs.angularjs.org/api/ng/service/$compile#description_comprehensive-directive-api_directive-definition-object
    return {
        restrict: "A",
        link: linkFunction
    };
}
